import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, InputAdornment, Skeleton, TextField, useTheme } from '@mui/material';
import NotificationsTable from './ManageNotificationsTable';
import { Notification2 } from '../../../app/services/api/generated';
import { SearchLg } from '../../../assets/';
import { EmptyTable } from '../../../components/shared/EmptyTable';

const inputStyling = {
  width: '320px',
  '& .MuiInputBase-root': {
    height: '40px',
  },
};

const NotificationsBox = (props: { notifications: Notification2[], loadData: () => void, isLoading: boolean, onCreate: () => void }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const theme = useTheme();
  const { t } = useTranslation('manageNotifications');
  const [transformedData, setTransformedData] = useState<Notification2[]>([]);

  useEffect(() => {
    setSearchTerm('');
    setTransformedData(props.notifications ?? []);
  }, [props.notifications]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    let filteredData = [...props.notifications];

    if (value && value !== '') {
      filteredData = props.notifications.filter(x =>
        x.title?.toLowerCase().includes(value.toLowerCase()));
    }

    setTransformedData(filteredData);
  };

  const handleClear = () => {
    setSearchTerm('');
    setTransformedData(props.notifications);
  };

  return (
    <Grid item
      mt={5}
      xs={12}
    >
      <Box paddingY={5}
        sx={{ display: 'flex', gap: 4, width: '100%' }}>
        <TextField
          onChange={(event) => handleSearch(event.target.value)}
          size='small'
          placeholder={t('search')}
          value={searchTerm}
          sx={{ ...inputStyling }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchLg />
              </InputAdornment>
            ),
          }}
        />
        <Button
          disabled={searchTerm === ''}
          variant="secondary"
          size="lg"
          onClick={() => handleClear()}
          sx={{ width: '100px' }}
        >
          {t('clearFilters')}
        </Button>
      </Box>
      {props.isLoading
        ? <Skeleton sx={{ bgcolor: theme.palette.custom.gray[100] }}
          variant='rectangular'
          height={445.89} />
        : transformedData.length == 0
          ?
          <EmptyTable
            text={t('notifications')}
            searchTerm={searchTerm}
            onClear={handleClear}
            onAdd={() => props.onCreate()}
            addItemText={t('newNotification')}
            onAddIsCreating={false}
            withPaginationShown={true}
            headerHeight={45}
            bodyRowHeight={30}
          />
          :
          <NotificationsTable
            notifications={transformedData}
            loadData={props.loadData}
          />
      }
    </Grid>
  );
};

export default NotificationsBox;